import { Component, Input } from '@angular/core';
import { OrderHeadGet } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-emails',
    templateUrl: './order-head-emails.component.html',
    styleUrls: ['./order-head-emails.component.css'],
})
export class OrderHeadEmailsComponent {
    @Input()
    public get?: OrderHeadGet;
}
